import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router'
import { AuthenticationService } from '../../core/_services/authentication.service';
import { AlertasService } from '../../core/_services/alerta.service';
import { CoreService } from '../../core/_services/core.services';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppBreadcrumbService } from './../app.breadcrumb.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, } from 'primeng/api';
import { ValidatorUtils } from '../../core/_util/validator-util';


@Component({
  selector: 'recuperar-contrasena',
  templateUrl: './recuperar-contrasena.component.html',
})
export class RecuperarContrasenaComponent extends ValidatorUtils implements OnInit {

  formBuilder: FormBuilder;
  formulario: FormGroup;

  cargandoPagina: boolean = false;
  submitted: Boolean = false;
  nuevaContrasena: any;
  mensaje: any;
  item: any;
  nombres: string;
  confirmacion: any;
  claveMax: Boolean = false;
  claveMin: Boolean = false;
  claveMayusc: Boolean = false;
  claveMinusc: Boolean = false;
  claveNum: Boolean = false;
  claveCaracter: Boolean = false;
  claveIgual: Boolean = false;
  claveNombre: Boolean = false;
  claveCedula: Boolean = false;
  datos: any;
  expreg = new RegExp("[A-Z]");
  expregmin = new RegExp("[a-z]");
  expregnum = new RegExp("[0-9]");
  expregcar = new RegExp("[)&.\-/:}=+*${;'#%(]");
  nuevaClave: any;
  token: any;
  constructor(
    private route: ActivatedRoute,
    private service: AuthenticationService,
    public msj: AlertasService,
    public coreService: CoreService,
    public confirmationService: ConfirmationService,
  ) {
    super();
    this.formBuilder = new FormBuilder();
    this.formulario = this.formBuilder.group({
      email: ['', [Validators.required]],
     
    });

   }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    this.coreService.get('/recuperar-contrasena-formulario?token='+this.token).subscribe(
      (res: any) => {
        this.datos = res.datos;
      },
      (err: any) => {
        console.log(err);
      }
    )
   
  }

  
  validaClavemax(e) {
    if (this.nuevaContrasena !== undefined) {
      if (this.nuevaContrasena.length > 40) {
        this.claveMax = false;
        return "red";
        
      } else {
        this.claveMax = true;
        return "green";
       
        
      }
    }
  }

  validaClavemin(e) {
    if (this.nuevaContrasena !== undefined) {
      if (this.nuevaContrasena.length < 8) {
        this.claveMin = false;
        return "red";
        
      } else {
        
        this.claveMin = true;
        return "green";
      }
    }
  }

  validaMayusc(e) {
    if (this.nuevaContrasena !== undefined) {
      if (!this.expreg.test(this.nuevaContrasena)) {
        this.claveMayusc = false;
        return "red";
      } else {
        this.claveMayusc = true;
        return "green";
      }
    }
  }

  validaMinusc(e) {
    if (this.nuevaContrasena !== undefined) {
      if (!this.expregmin.test(this.nuevaContrasena)) {
        this.claveMinusc = false;
        return "red";
      } else {
        this.claveMinusc = true;
        return "green";
      }
    }
  }

  validaNumero(e) {
    if (this.nuevaContrasena !== undefined) {
      if (!this.expregnum.test(this.nuevaContrasena)) {
        this.claveNum = false;
        return "red";
      } else {
        this.claveNum = true;
        return "green";
      }
    }
  }

  validaCaracter(e) {
    if (this.nuevaContrasena !== undefined) {
      if (!this.expregcar.test(this.nuevaContrasena)) {
        this.claveCaracter = false;
        return "red";
      } else {
        this.claveCaracter = true;
        return "green";
      }
    }
  }


  validaIgual(e) {
    if (this.nuevaContrasena !== undefined && this.confirmacion !== undefined) {
     
      if (this.nuevaContrasena === this.confirmacion) {
        this.claveIgual = true;
        return "green";
      } else {
        this.claveIgual = false;
        return "red";
      }

    }

  }

  validaNombre(e) {
    if (this.nuevaContrasena !== undefined) {
      let array=[];
     const nombre=this.datos.nombres.split(' ');
     for (let i = 0; i < nombre.length; i++) {
      if (nombre[i] != "") {
        array.push(nombre[i]);
      }
    }
     for (let i = 0; i < array.length; i++) {
      if (this.nuevaContrasena.includes(array[i].toLowerCase())){
        this.claveNombre= false;
        return "red";
     
    }
  }

  let arraydos=[];
  const papellido=this.datos.primer_apellido.split(' ');
  for (let i = 0; i < papellido.length; i++) {
   if (papellido[i] != "") {
     arraydos.push(papellido[i]);
   }
 }
  for (let i = 0; i < arraydos.length; i++) {
   if (this.nuevaContrasena.includes(arraydos[i].toLowerCase())){
     this.claveNombre= false;
     return "red";
  
 }
}



      if (this.nuevaContrasena.includes(this.datos.segundo_apellido.toLowerCase()) || this.nuevaContrasena.includes(this.datos.email.toLowerCase())){
        this.claveNombre= false;
        return "red";
      } else {
        this.claveNombre = true;
        return "green";
      }
    }
  }
 
  validaCedula(e) {
    if (this.nuevaContrasena !== undefined) {
      
      if (this.nuevaContrasena.includes(this.datos.numero_id)){
        this.claveCedula = false;
        return "red";
      } else {
        this.claveCedula = true;
        return "green";
      }
    }
  }


  guardar() {
    var dat = this.formulario.valid;
    this.formulario.markAllAsTouched();
    if (dat) {
    if (this.claveMax && this.claveMin && this.claveCaracter && this.claveCedula && this.claveIgual && this.claveMayusc && this.claveMinusc && this.claveNombre && this.claveNombre) {
      this.confirmationService.confirm({
        message: '¿Deseas restablcer la contraseña?',
        accept: () => {
          this.submitted = true;
          this.cambiarContrasena();
        }
      });
    
  }else{

    this.msj.info("La contraseña no cumple con las condiciones");

  }
  }
}

cambiarContrasena(){

  let data = {
    ncontrasena: this.nuevaContrasena,
    email: this.formulario.value.email,
    token:this.token,
  }
  this.coreService.post('/recuperar-contrasena-post',data).subscribe(
    (res: any) => {
     
      this.msj.info(res);
     

    },
    (err: any) => {
     
      this.msj.info(err);
    }
  )
}


}

